import React, { useCallback, useState } from 'react';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, useGetSchema, usePost, usePut } from '../../apiHooks';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const PermissionsProvider: React.FC<Props> = ({ children }: Props) => {
    const [data, setData] = useState([]);
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const getSchema = useGetSchema(api, schema, setSchema, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
        setSelected(item);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, setSelected, setError);

    // const handleDeleteCallback = useCallback((id, newData) => {
    //     setData(newData);
    //     setSelected({});
    //     return id;
    // }, []);
    // const remove = useRemove(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                // remove,
                error
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default PermissionsProvider;
